/**
 * To'lovdan qaytish bayroqlari.
 *
 * MUHIM: bu qiymatlar modul birinchi marta import qilingan paytda — ya'ni React
 * render, auth (login) flow va har qanday `useEffect` dan OLDIN — bir marta
 * o'qiladi. Shu sabab hech qanday effect tartibi, React StrictMode double-invoke
 * yoki dev-server HMR holati ularni "yo'qotib" qo'ya olmaydi: URL hali pristine
 * (toza) bo'lgan paytda olamiz.
 *
 * App keyinchalik `window.history.replaceState` bilan paramni URL dan tozalashi
 * mumkin — bu const ga ta'sir qilmaydi (qiymat allaqachon olib bo'lingan).
 */

function readFlag(name: string): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get(name) === "1";
}

/** Click/Payme `BAZAAR_RETURN_URL` (.../?bazaar=1) orqali qaytildimi. */
export const RETURNED_TO_BAZAAR = readFlag("bazaar");
